// polyfills.js 
import A from "core-js/stable";
import B from 'core-js/features/array/includes';
import C from 'core-js/proposals/relative-indexing-method';
import D from 'core-js/es/object/has-own';
// force import: ref: https://github.com/zloirock/core-js/issues/1114#issuecomment-1214818075
// eslint-disable-next-line no-unused-expressions
A; B; C; D;
// polyfills.js 